import { Functionality } from '@frontend/functionality/types';
import { getFunctionalityDisplayName, useFunctionalityBlobImage } from '@frontend/functionality/utils';
import { ICONS, getIconByValue } from '@frontend/icons';
import { useRef } from 'react';
import { useIntl } from 'react-intl';

import useLicenseNavigationCard from './license-navigation-card.controller';

const ID = 'license-navigation-card';
export interface LicenseNavigationCardProps {
    functionality: Functionality;
}

const LicenseNavigationCard = (props: LicenseNavigationCardProps) => {
    const viewProps = useLicenseNavigationCard(props);
    const intl = useIntl();
    const blobImageUrl = useFunctionalityBlobImage(props.functionality);
    const Icon = props.functionality.icon ? getIconByValue(props.functionality.icon) : ICONS.APPLICATION.my;
    const SubIcon = props.functionality.sub_icon ? getIconByValue(props.functionality.sub_icon) : null;
    const ref = useRef<HTMLParagraphElement>(null);

    const isOverflown = () => {
        if (!ref.current) return false;
        return ref.current?.scrollHeight > 48 * 2.25;
    };

    const mainIcon = blobImageUrl ? (
        <img
            src={blobImageUrl}
            alt=''
            className={props.functionality.pre_branded_icon ? 'h-full w-auto max-w-full object-contain' : 'size-6 object-contain'}
        />
    ) : (
        <Icon className={props.functionality.pre_branded_icon ? 'h-full w-auto max-w-full' : 'size-6'} />
    );

    return (
        <div
            id={ID}
            data-testid={`${props.functionality.name.toLowerCase().replace(/\s/g, '_')}`}
            className='bg-background-surface relative flex flex-1 flex-col gap-2 self-stretch rounded-2xl p-4'
            onClick={viewProps.onNavigate}>
            {props.functionality.pre_branded_icon ? (
                <div className='flex h-10 max-w-full items-center'>{mainIcon}</div>
            ) : (
                <div className='text-background-surface size-10'>
                    <div className='bg-brand-primary flex size-10 items-center justify-center rounded-full'>{mainIcon}</div>

                    {SubIcon && (
                        <div className='bg-brand-muted absolute top-4 left-10 inline-flex size-4 items-center justify-center rounded-full'>
                            <SubIcon className='size-2.5' />
                        </div>
                    )}
                </div>
            )}

            <div className={`text-foreground-default line-clamp-2 flex h-12 min-w-20 text-base font-medium ${isOverflown() ? 'items-start' : 'items-end'}`}>
                <p ref={ref}>{getFunctionalityDisplayName(intl, props.functionality)}</p>
            </div>
        </div>
    );
};

export default LicenseNavigationCard;
